
<template>
    <div class="login-div">
	   <!-- echarts -->
      <div class="echartsCon flexC">
          <div class="titleCon flexCC flexD">
              <div  class="titleConItem flexBC">
                   <div class="desc">{{$t('userManage.topTotal1')}}</div>
                   <div class="num">
                       <span>{{indexData.total}}</span>
                   </div>
              </div>
              <div  class="titleConItem flexBC">
                   <div class="desc">{{$t('userManage.topTotal2')}}</div>
                   <div class="num">
                       <span>{{indexData.signIn30}}</span>
                   </div>
              </div>
              <div  class="titleConItem flexBC">
                   <div class="desc">{{$t('userManage.topTotal3')}}</div>
                   <div class="num">
                       <span>{{indexData.userCountOnline}}</span>
                   </div>
              </div>
              
          </div>
          <div id="main"></div>
      </div>

      <!-- 搜索 -->
       <div class="search-div flexC">

            <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.dealerUserGroup")}}</div>
                <Select :loading="userGroupLoading" :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.dealerUserGroupId" >
                    <Option v-for="(item, index) in searchObjArr.userGroups" :value="item.id" :key="index">{{item.groupName}}</Option>
                </Select>
            </div>
            
             <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.emailAddress")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.emailAddress" ></Input>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.phoneNumber")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.phoneNumber" ></Input>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.userAccount")}}</div>
               <!-- <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.userAccount" ></Input> -->
               <InputNumber class="input-div" :min="1" :precision='0'  :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.userAccount" ></InputNumber>
            </div>

            

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.os")}}</div>
                <Select  :placeholder='$t("selectPlaceholder")'  clearable class="input-div" v-model="searchObj.os" >
                    <Option v-for="(item, index) in searchObjArr.type" :value="item.id" :key="index" style="height:50px">{{item['val']}}</Option>
                </Select>
            </div>

              <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.livenessLessThen")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.livenessLessThen" ></Input>
            </div>

             <div class="search-div-item flexC">
               <div class="labelText">{{$t("userManage.livenessGreaterThen")}}</div>
               <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable v-model="searchObj.livenessGreaterThen" ></Input>
            </div>


             <div class="search-div-item">
                <Button type="info" @click="searchItem"  icon="ios-search" style="marginTop:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{$t('search')}}</Button>
             </div>
         
        </div>

        <!-- 表格 -->
        <div class="tableCon">
            <div class="top flexBC">
                <div>
                     <Button type="primary" :disabled="buttonList.editDisabled" @click="moveData" style="margin-right:8px;">{{$t("userManage.Move")}}</Button>
                     <Button type="error" :disabled="buttonList.editDisabled" :loading="banLoading" @click="blockUser(1)" style="margin-right:8px;">{{$t("userManage.Block")}}</Button>
                     <Button type="warning" :disabled="buttonList.editDisabled" :loading="unBanLoading" @click="blockUser(2)" style="margin-right:8px;">{{$t("userManage.Unlock")}}</Button>
                     <Button type="info" :disabled="buttonList.addDisabled" @click="addData" style="margin-right:8px; border-radius: 6px;">{{$t("userManage.ManageGroup")}}</Button>
                </div>
            </div>

           <Table :columns="titleName" :loading="loading" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange"></Table>
           <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
        </div>

         <!-- 移动  模态框组件 -->
           <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormDataArr"></ModelBox>

          <!-- 管理组织 -->
          <manageModelBox :showModel.sync="detailBox.showModel" :fn="detailBox.callbackFn"  :editFormData="detailBox.editFormData"></manageModelBox>
          
         
    </div >
    
</template>

<script>
import common from "@/common/common.js";
import moment from "moment";
import ModelBox from './component/addModel';
import manageModelBox from './component/manageModel.vue';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import timerJs from "@/common/time.js"
import {mapState} from 'vuex'

export default {
  name: "userManage",
  components: {
       ModelBox,
       manageModelBox,
       DeleteDialog
  },
  data() {
    return {
          loading: true,
          banLoading:false,
          unBanLoading:false,
          type:1,//弹框打开类型 1添加 2编辑
          tableList:{//表格组
              hasSelectData:{},//已选中的行的数据
              hasSelectDataArr:[],//已选中的行的数据数组
              tableData: []//表格数据
          },
          indexData:{
              total:'',
              userCountOnline:'',
              signIn30:'',
          },
          buttonList:{//按钮组
              addDisabled:false,//添加按钮是否禁用
              editDisabled:true,//编辑按钮是否禁用
              delDisabled:true,//删除按钮是否禁用
          },
          addBox:{//规格弹框组-移动
              showModel:false,//弹框开关
              callbackFn:()=>{}, //弹框的回调函数
              editFormData:{},//编辑时传入的现有数据
          },
          detailBox:{//规格弹框组-详情
              showModel:false,//弹框开关
              callbackFn:()=>{}, //弹框的回调函数
              editFormData:{},//编辑时传入的现有数据
          },
          page:{//分页排序
              total:0,//总条数
              pageSize:10,//每页条数
              current:1,//当前页
              key:'createdAt',
              order:'desc'
          },
         
          chartData:{//图表数据
              dataList:[],
              monthList:[]
          },
          userGroupLoading:false,
          searchObj:{
              os:"",
              dealerUserGroupId:"",
              emailAddress:"",
              userAccount:null,
              phoneNumber:"",
              livenessLessThen:"",
              livenessGreaterThen:""
          }
	};
  },
  computed:{
        ...mapState(['local','selectId']),
        searchObjArr(){
            return {
                type:[
                    {id: 1,val:'android'},
                    {id: 2,val:'ios'}
                ],
                userGroups:[]
           }
        },
        titleName(){
            return [
               {
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    fixed: 'left'
                },
               {
                  title: this.$t('userManage.titleName.Account'),
                  'title-zh-CN':'账号',
                  'title-en-US':'Account',
                  key: 'id',
                  sortable: true,
                  minWidth: 130
              },
               {
                  title: this.$t('userManage.titleName.Email'),
                  'title-zh-CN':'邮箱',
                  'title-en-US':'Email',
                  key: 'emailAddress',
                  sortable: true,
                  minWidth: 260
              },
               {
                  title: this.$t('userManage.titleName.Group_name'),
                  'title-zh-CN':'组织名称',
                  'title-en-US':'Group name',
                  key: 'groupName',
                  sortable: true,
                  minWidth: 140
              },
               {
                  title:this.$t('userManage.titleName.Status'),
                  'title-zh-CN':'状态',
                  'title-en-US':'Status',
                  key: 'status',
                  sortable: true,
                  minWidth: 120,
                  render:(h, params)=>{
  
                       let flag1 = params.row.status
                       let flag2 = params.row.whetherOnline?'1':'2'
                       let flag = flag1==3?'3':flag2
                       let obj = {'1':this.$t('selectList.onlineType.Online'),'2':this.$t('selectList.onlineType.Outline'),'3':this.$t('selectList.onlineType.Disabled')}
                       let stext = obj[flag]
        
                       return h('div',{
                           style:{
                               color:flag==3?'#ed4014':'#5a516e'
                           }
                       },stext || '')
                  }
              },
               {
                  title: this.$t('userManage.titleName.Operational'),
                  'title-zh-CN':'系统',
                  'title-en-US':'Operational',
                  key: 'os',
                  minWidth: 140,
                  render:(h, params)=>{
                       let obj = {'1':'android','2':'ios'}
                       let stext = obj[params.row.os]
                       return h('div',stext || '')
                  }
              },
              {
                  title: this.$t('userManage.titleName.App'),
                  'title-zh-CN':'app应用',
                  'title-en-US':'App',
                  key: 'appVersion',
                  minWidth: 100
              },
              {
                  title: this.$t('userManage.titleName.Liveness'),
                  'title-zh-CN':'活跃度',
                  'title-en-US':'Liveness',
                  key: 'liveness',
                  minWidth: 100
              },
               {
                  title: this.$t('userManage.titleName.Registration_time'),
                  'title-zh-CN':'注册时间',
                  'title-en-US':'Registration time',
                  key: 'createdAt',
                  minWidth: 180,
                  render:(h, params)=>{
                      let stext = moment(params.row.createdAt*1).format('YYYY-MM-DD HH:mm:ss')
                       return h('div',stext || '')
                  }
              },
              {
                  title: this.$t('userManage.titleName.Phone'),
                  'title-zh-CN':'联系电话',
                  'title-en-US':'Phone',
                  key: 'phoneNumber',
                  minWidth: 150,
                  render:(h, params)=>{
                       let stext = params.row.phonePrefix?params.row.phonePrefix+'-'+params.row.phoneNumber:params.row.phoneNumber
                       return h('div',stext || '')
                  }
              },
              {
                  title: this.$t('userManage.titleName.Contact_address'),
                  'title-zh-CN':'联系地址',
                  'title-en-US':'Contact address',
                  key: 'area',
                  minWidth: 160
              }
           ]
        }

  },
  created() {
      this.getData();
      this.getTopData()
      this.getchartData();
      this.getSelect()
  },
  watch: {
   },
  mounted(){
     
  },
  methods: { 
        getSelect(){//获取下拉数据
            this.userGroupLoading = true
            this.axios.post(this.config.urlArray.userGroups, {dealerId:this.selectId}).then((result) => {
                // common.ajaxMsg(result.data,false);
                let resData = result.data.data
                //处理数组
                this.searchObjArr.userGroups  = resData
                this.userGroupLoading = false
                // console.log('resDataresData',resData)
            }).catch((err) => {
                common.msg('error','获取失败',()=>{})
            });
 
        },
        getchartData(){//图表数据
            this.chartData.monthList = timerJs.getOldMonth();
            let data = {
                chartList:this.chartData.monthList,
                dealerId:this.selectId
            }
            this.axios.post(this.config.urlArray.userChart, this.chartData.monthList).then(result => {
		      common.ajaxMsg(result.data,false,()=>{
                  this.chartData.dataList = result.data.data
                  this.initEcharts()
              })
		    }).catch(err => {
		    //   common.msg('error', err, () => {})
		    })

        },
        getTopData(){//汇总数据
            this.axios.post(this.config.urlArray.OnlineNumber, {dealerId:this.selectId}).then(result => {
		      common.ajaxMsg(result.data)
              this.indexData.userCountOnline = result.data.data
		    }).catch(err => {
		      common.msg('error', err, () => {})
		    })

            this.axios.post(this.config.urlArray.userCount, {dealerId:this.selectId}).then(result => {
		    //   common.ajaxMsg(result.data)
              this.indexData.total = result.data.data
		    }).catch(err => {
		    //   common.msg('error', err, () => {})
		    })

            let myDate  = new Date();
           
			let myflag = myDate.getFullYear()+'-'+(myDate.getMonth()+1)+'-'+myDate.getDate()+" 00:00:00";    

            let myDate1  = new Date(myDate.getTime()-60*60*24*1000*31);
            let myflag2  = myDate1.getFullYear()+'-'+(myDate1.getMonth()+1)+'-'+myDate1.getDate()+" 00:00:00"; 

            let dataobj = {
				    params:{
				    	startDate:(new Date(myflag2)).getTime(),
				    	endDate:(new Date(myflag)).getTime()-1000,
                        dealerId:this.selectId
				    }
			    }
            this.axios.post(this.config.urlArray.userCount, dataobj.params).then(result => {
		    //   common.ajaxMsg(result.data)
              this.indexData.signIn30 = result.data.data
		    }).catch(err => {
		    //   common.msg('error', err, () => {})
		    })
        

        },
        blockUser(type){//1封禁、2解封
            
            let formDataArr = {enable:false,userIds:[]}
            this.tableList.hasSelectDataArr.map(item=>{
                
                if(type==1){
                    formDataArr.enable = false
                    this.banLoading = true
                }else if(type==2){
                    formDataArr.enable = true
                    this.unBanLoading = true
                }
                formDataArr.userIds.push(item.userId)
            })

            // console.log('formDataArr',formDataArr)

            
       
            this.axios.post(this.config.urlArray.userEnable, formDataArr).then((result) => {
                common.ajaxMsg(result.data,true,()=>{
                  
                    this.clearbtnStatus()
                    this.getData()
                },()=>{
                    this.banLoading = false
                    this.unBanLoading = false
                });

            }).catch((err) => {
                // common.msg('error','获取失败',()=>{})
            });
        },
        moveData() {  //移动数据
            this.addBox.showModel = true
            // this.addBox.editFormData = this.tableList.hasSelectData
            this.addBox.editFormDataArr = this.tableList.hasSelectDataArr
            this.addBox.callbackFn = () => {//回调处理
                //重新载入
                this.clearbtnStatus()
                this.addBox.showModel = false;
                this.getData();
            }
        },
        addData(row){
            this.detailBox.showModel = true
            this.detailBox.editFormData = row
            this.detailBox.callbackFn = () => {//回调处理
                //重新载入
                this.clearbtnStatus()
                this.detailBox.showModel = false;
                // this.getData();
            }
        },

	    initEcharts(){
			 let myEchart = this.$echarts.init(document.getElementById("main"));
             let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    toolbox: {
                        feature: {
                            dataView: {show: false, readOnly: false},
                            magicType: {show: false, type: ['bar']},
                            restore: {show: false},
                            saveAsImage: {show: false}
                        }
                    },
					color:['#91CC75','#FAC244'], //关键加上这句话，legend的颜色和折线的自定义颜色就一致了
                    legend: {
                        data: ['个数', '个数']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.chartData.monthList,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            // name: '水量',
                            // min: 0,
                            // max: 250,
                            // interval: 50,
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            type: 'value',
                            // name: '温度',
                            // min: 0,
                            // max: 25,
                            // interval: 5,
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [
                   
                        {
                            name: this.local=='en-US'?'Registered users':'注册数',
                            type: 'bar',
                            data:  this.chartData.dataList,
							itemStyle: {
                                normal: {
                                  color: function (params) {
                                    //自定义颜色
                                    var colorList = ['#91CC75','#FAC244'];
                                    return colorList[0]
                                  }
                                }
                            }
                        },
                      
                    ]
             };
             myEchart.setOption(option);

		},
        searchItem(){ //搜索
            this.getData()
        },
        getData() {//获取数据
            let getData = {
                params: {
                    page: this.page.current,
                    limit: this.page.pageSize,
                    sortfield: this.page.key,
                    ascDesc: this.page.order,
                    dealerId:this.selectId
                }
            }
           
            Object.assign(getData.params,this.searchObj)
            for(let key in getData.params){
                if(!getData.params[key]){
                    delete getData.params[key]
                }
            }
            this.loading = true

            this.axios.post(this.config.urlArray.appUsersList, getData.params).then((result) => {
                common.ajaxMsg(result.data,false,()=>{
                    let resData = result.data.data.userList
                    //处理数组
                    this.tableList.tableData  = resData
                    this.page.total = result.data.data.count
                    this.loading = false
                },()=>{
                    // this.loading = false
                });
            }).catch((err) => {
                // common.msg('error','获取失败',()=>{})
            });
        },
        sortCustom(data) {//自定义排序
            this.page.key = data.key
            this.page.order = data.order
            this.getData()
        },
        
        selectChange(res) { //控制编辑和删除按钮的可用状态
            // console.log(res,'44')
            if(res.length >= 1){
                this.buttonList.editDisabled = this.buttonList.delDisabled = false
                this.tableList.hasSelectData = res[0]
                this.tableList.hasSelectDataArr = res
            }else{
                this.buttonList.editDisabled = this.buttonList.delDisabled = true
                this.tableList.hasSelectData = {}
                this.tableList.hasSelectDataArr = []
            }
        },

        changePage(nowpage) {//切换分页
            this.page.current = nowpage;
            this.getData();
        },
        changeSize(nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getData()
        },
        clearbtnStatus() { //删除后清空编辑数据 与按钮状态
            this.buttonList.delDisabled = true
            this.buttonList.editDisabled = true
            this.banLoading = false
            this.unBanLoading = false
            this.tableList.hasSelectData = {}
        },
    
  }
};
</script>

 <style scoped lang="less">
 .labelText{
     line-height: 54px;
     height: 54px;
     flex-shrink: 0;
     margin-right: 10px;
 }
 .echartsCon{
    background: #fff;
    margin: 40px 40px;
    border-radius: 14px;
    padding: 20px 40px;
     #main {
       // width: 100%;
   	   flex-grow:1;
       height:400px;
       margin: auto;
       margin-top: 30px
     }
     .titleCon{
       width: 350px;
       flex-shrink: 0;
       .titleConItem{
           border-bottom: 2px solid #EEF1F4;
           padding: 20px 18px 20px 35px;
           color: #3A464E;
           position: relative;
           &:nth-last-of-type(1){
               border-bottom:none
           }
           &::before{
               content: '';
               position: absolute;
               left: 12px;
               top:50%;
               transform: translateY(-50%);
               width: 6px;
               height: 26px;
               background: #4E77EF
           }
           &:nth-of-type(2){
                &::before{
                    background: #FFB139
                }
           }
           &:nth-of-type(3){
                &::before{
                    background: #3BC1DB
                }

           }

           .num{
               font-size: 20px;
               font-weight: bold;
           }
           .desc{
               height: 30px;
               line-height: 30px;
           }
           
       }
     }

 }

 .search-div{
     flex-wrap: wrap;
     background-color: #fff;
     padding: 34px 40px ;
     background: #FFFFFF;
     margin: 20px 40px;
     border-radius: 14px;
     .search-div-item{
         margin-right: 20px;
         span{
             margin-right: 30px;
         }
     }
      /deep/ .ivu-select-single .ivu-select-selection{
        height: 44px;
        width: 200px;
     }
     /deep/  .ivu-input{
        height: 44px;
        line-height: 44px;
     }
     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }

     /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
         height:44px;
         line-height: 44px;
     }
     /deep/ .ivu-input-icon{
          height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number-input-wrap{
         height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number{
         height:44px;
         line-height: 44px;
     }
      /deep/  .ivu-input-number-handler{
         height:22px;
         line-height:22px;
     }
      /deep/ .ivu-input-number-handler-up-inner{
         line-height:22px;
     }
      /deep/ .ivu-input-number-handler-down-inner{
         line-height:22px;
     }
 }


 .tableCon{
     background-color: #fff;
     padding: 34px 40px 1px 34px;
     background: #FFFFFF;
     margin: 20px 40px;
     border-radius: 14px;
     .top{
         margin: 0 0 30px;
         .optionsIcon{
             margin-right: 15px;
         }
         .moveBotton{
             background: #3BC1DB;
             color: #fff;
             border-color: #3BC1DB;
             border-radius: 6px;
         }
     }
 }

</style>
